// crewbit-admin/src/hooks/useCreateWalkInPending.ts
//
// Schedule Module Phase C C5A — paired hook for `create_walk_in_pending` RPC
// (Migration 317 — §Schedule.WalkInQueueSubstrateSplit).
// Mirror of crewbit-mobile/hooks/useCreateWalkInPending.ts; bodies byte-identical
// modulo import paths (per feedback_admin_pair_must_match_mobile_body.md).

import { useCallback } from 'react';
import { callScheduleRpc, type ScheduleRpcResult } from '../lib/scheduleRpc';

export interface CreateWalkInPendingInput {
  businessId: string;
  /** REQUIRED — UUID v4 from form-load (idempotency replay protection). */
  idempotencyKey: string;
}

export type CreateWalkInPendingResult = ScheduleRpcResult<{
  success: true;
  walk_in_id: string;
  already_created?: boolean;
}>;

export function useCreateWalkInPending() {
  return useCallback(
    async (input: CreateWalkInPendingInput): Promise<CreateWalkInPendingResult> => {
      return callScheduleRpc<{
        success: true;
        walk_in_id: string;
        already_created?: boolean;
      }>('create_walk_in_pending', {
        p_business_id: input.businessId,
        p_idempotency_key: input.idempotencyKey,
      });
    },
    [],
  );
}
